import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Notification from 'utils/Notifications'
import {
  getForm1NK,
  downloadForm1NK,
} from 'service/ReportsService'
import {
  PageHeader,
  UnvButton,
  Skeleton,
  ErrorState,
  EmptyState,
  Card,
} from 'components'

import Form1NKTable from './components/Form1NKTable/Form1NKTable'
import YearFilter from './components/YearFilter/YearFilter'
import styles from './Form1NKPage.module.scss'

const Form1NKPage = () => {
  const { t } = useTranslation('common')
  const currentYear = new Date().getFullYear()
  const [year, setYear] = useState(currentYear)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })

  const load = async (y) => {
    setLoading(true)
    setError(false)
    try {
      const res = await getForm1NK(y)
      setData(res.data || null)
    } catch {
      setError(true)
      setData(null)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load(year) }, [year])

  const handleDownload = async (fmt) => {
    try {
      await downloadForm1NK(year, fmt)
      setNotify({ isOpen: true, message: t('reports.file_downloaded'), type: 'success', sound: 'success' })
    } catch {
      setNotify({ isOpen: true, message: t('reports.file_download_failed'), type: 'error', sound: 'error' })
    }
  }

  return (
    <div className={styles.page}>
      <PageHeader
        title={t('reports.form1nk_title')}
        subtitle={t('reports.form1nk_subtitle')}
        actions={
          <>
            <UnvButton variant="secondary" iconLeft="download" onClick={() => handleDownload('xlsx')}>
              XLSX
            </UnvButton>
            <UnvButton variant="secondary" iconLeft="download" onClick={() => handleDownload('csv')}>
              CSV
            </UnvButton>
          </>
        }
      />

      <Card className={styles.toolbar}>
        <YearFilter value={year} onChange={setYear} />
        <UnvButton variant="primary" iconLeft="refresh" onClick={() => load(year)}>
          {t('reports.load_btn')}
        </UnvButton>
      </Card>

      <Card className={styles.content}>
        {loading ? (
          <Skeleton variant="table" rows={8} cols={6} />
        ) : error ? (
          <ErrorState title={t('reports.form1nk_load_failed')} onRetry={() => load(year)} />
        ) : !data ? (
          <EmptyState iconName="folder" title={t('reports.form1nk_load_failed')} />
        ) : (
          <Form1NKTable data={data} />
        )}
      </Card>

      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default Form1NKPage
